import axios from 'axios';
import {
  AuthSetupDetails,
  ISendPhoneVerificationCodeRequest,
  IVerifyPhoneVerificationCodeRequest,
} from 'models/auth-setup';
import { createStandardResponse, StandardResponse } from 'models/standard-response';
import BaseService from 'services/base-service';
import { store } from 'store';
import type { ICountryDetail } from 'types/stateTypes';
import { env } from 'config/env';

export const getAuthOptions = async (): Promise<StandardResponse<AuthSetupDetails>> => {
  try {
    const res = await BaseService({
      url: `driver/2fa/status`,
      method: 'GET',
    });
    return createStandardResponse<AuthSetupDetails>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const setAuthPreference = async (methodCode: string): Promise<StandardResponse<boolean>> => {
  try {
    const res = await BaseService({
      url: `/driver/2fa/preference`,
      method: 'PUT',
      data: { method_code: methodCode },
    });
    return createStandardResponse<boolean>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const resetAuthSetup = async (email: string): Promise<StandardResponse<boolean>> => {
  try {
    const res = await BaseService({
      url: `/driver/2fa/default-preference?email=${email}`,
      method: 'PUT',
      data: { byPassAuth: true },
    });
    return createStandardResponse<boolean>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const getCountryCodesFlagsDetails = async (
  language?: string,
  isFilterByCountry?: boolean,
): Promise<{ data: ICountryDetail[] }> => {
  const languageCode = store?.getState()?.LanguageInfo?.defaultLanguage?.code
    ? store?.getState()?.LanguageInfo?.defaultLanguage?.code
    : 'en';
  const headers = {
    language: language || languageCode,
    Authorization: env.VITE_GLOBAL_SERVICE_API_TOKEN,
  };

  const baseURL = `${env.VITE_GLOBAL_API_SERVER}/v1.0/global-services/country-details`;

  const finalURL = isFilterByCountry ? `${baseURL}?filter_by_whatsapp_support=true` : baseURL;

  try {
    const res = await axios.get(finalURL, {
      headers: headers,
    });
    return Promise.resolve(res.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const sendPhoneVerificationCode = async (data: ISendPhoneVerificationCodeRequest) => {
  try {
    const res = await BaseService({
      url: `/driver/2fa/phone-number/send/otp`,
      method: 'POST',
      data,
    });
    return createStandardResponse<boolean>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const verifyPhoneVerificationCode = async (data: IVerifyPhoneVerificationCodeRequest) => {
  try {
    const res = await BaseService({
      url: `/driver/2fa/phone-number/verify/otp`,
      method: 'POST',
      data,
    });
    return createStandardResponse<boolean>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};
